import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, Inject, ChangeDetectorRef, OnInit } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

export interface MappedService {
  serviceName: string;
  components: string[];
}

@Component({
    standalone: true,
    imports: [CommonModule, AgGridModule], // <-- Add AgGridModule here
    selector: 'app-service-mapping-dialog',
    templateUrl: './service-mapping-dialog.component.html',
    styleUrl: './service-mapping-dialog.component.scss'
})
export class ServiceMappingDialogComponent implements OnInit {
title = 'Service Mapping';
  statusdata: MappedService[] = [];

columnDefs = [
  { headerName: 'Service Name', field: 'serviceName', flex: 1, cellStyle: { textAlign: 'left' } },
  {
    headerName: 'Components',
    field: 'components',
    flex: 2,
    valueGetter: params =>
      Array.isArray(params.data.components)
        ? params.data.components.join(', ')
        : params.data.components,
    cellStyle: { textAlign: 'left', whiteSpace: 'normal' }
  }
];

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, mappedServicesList: MappedService[] },
    private dialogRef: MatDialogRef<any>,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
     this.title = this.data.title || '';
    if (this.data.mappedServicesList) {
        try {
          this.statusdata = this.data.mappedServicesList || [];
        } catch (e) {
          console.error('Invalid Status Log:', e);
        }
        this.cdr.detectChanges(); // Force update
      
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}